<template>
  <div>
    <div v-show="cookiesVisibility" v-if="getLanguagePL">
      Zgadzam się na cookies <a href="/regulamin-cookie/">Link do Cookies</a>
      <i class="fa fa-close" @click="hideCookies"></i>
    </div>
    <div v-show="cookiesVisibility" v-if="getLanguageEN">
      I agree to cookies <a href="/regulamin-cookie/">Link to Cookies</a>
      <i class="fa fa-close" @click="hideCookies"></i>
    </div>
    <div v-show="cookiesVisibility" v-if="getLanguageUA">
      Я погоджуюсь на використання файлів сookie
      <a href="/regulamin-cookie/">Посилання на файли cookie</a>
      <i class="fa fa-close" @click="hideCookies"></i>
    </div>
    <div v-show="cookiesVisibility" v-if="getLanguageES">
      Acepto las cookies <a href="/regulamin-cookie/">Enlace a las cookies</a>
      <i class="fa fa-close" @click="hideCookies"></i>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cookiesVisibility: true
    };
  },
  methods: {
    hideCookies() {
      localStorage.setItem("OMEXcookie", "yes");
      this.cookiesVisibility = false;
    }
  },
  computed: {
    getLanguagePL() {
      return document.documentElement.lang === "pl-PL";
    },
    getLanguageEN() {
      return document.documentElement.lang === "en-US";
    },
    getLanguageUA() {
      return document.documentElement.lang === "uk-UA";
    },
    getLanguageES() {
      return document.documentElement.lang === "es-ES";
    }
  },
  created() {
    let cookie = localStorage.getItem("OMEXcookie");
    if (cookie) {
      this.cookiesVisibility = false;
    }
  }
};
</script>
<style>
.fa-close {
  cursor: pointer;
}
.fusion-contact-info a {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/Cookie.vue